import React from 'react';

const Pagination = ({ currentPage, totalCount, pageSize = 10, pageBlock = 5, onPageChange }) => {
  const totalPages = Math.ceil(totalCount / pageSize);
  if (totalPages < 2) return null;
  const blockStart = Math.floor((currentPage - 1) / pageBlock) * pageBlock + 1;
  const blockEnd = Math.min(blockStart + pageBlock - 1, totalPages);
  const pages = [];
  for (let i = blockStart; i <= blockEnd; i++) pages.push(i);

  return (
    <div className="pagination_container mt-3">
      {blockStart > 1 && (
        <div className="page_item arrow prev" onClick={() => onPageChange(blockStart - 1)}>
          «
        </div>
      )}
      {pages.map(p => (
        <div
          key={p}
          className={`page_item${p === currentPage ? ' active' : ''}`}
          onClick={() => onPageChange(p)}
        >
          {p}
        </div>
      ))}
      {blockEnd < totalPages && (
        <div className="page_item arrow next" onClick={() => onPageChange(blockEnd + 1)}>
          »
        </div>
      )}
    </div>
  );
};

export default Pagination;
